import { createDefaultTyrann } from '@apis/common';
import {
  bookingInquiryGetQuery,
  bookingInquiryGetQueryOrdering,
  bookingInquiryLimits,
  bookingInquiryPages,
  bookingInquiryPostResponse,
  postBookingInquiry,
  inquiryCancelDetailBody,
  inquiryDetail,
} from '@models/BookingInquiry';
import { bookingInquiryChangeLog } from '@models/BookingInquiryChangeLog';
import { bookingInquiryDraft, postBookingInquiryDraft } from '@models/BookingInquiryDraft';
import * as t from 'io-ts';

export type BookingInquiryGetQueryOrdering = t.TypeOf<typeof bookingInquiryGetQueryOrdering>;
export type BookingInquiryGetQuery = t.TypeOf<typeof bookingInquiryGetQuery>;
export type PostBookingInquiry = t.TypeOf<typeof postBookingInquiry>;
export type InquiryCancelDetailBody = t.TypeOf<typeof inquiryCancelDetailBody>;

export const bookingInquiryApis = createDefaultTyrann({
  '/booking-inquiry/': {
    get: {
      query: bookingInquiryGetQuery,
      response: {
        200: bookingInquiryPages,
      },
    },
    post: {
      body: postBookingInquiry,
      response: {
        200: bookingInquiryPostResponse,
        400: t.type({}),
      },
    },
  },
  '/booking-inquiry/{d2d_no}/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: inquiryDetail,
      },
    },
  },
  '/booking-inquiry/can-view/': {
    post: {
      body: t.type({
        d2d_no: t.string,
        viewer: t.string,
      }),
      response: {
        201: t.unknown,
        400: t.type({
          code: t.union([t.literal('ONESELF'), t.literal('REPEATED')]),
        }),
      },
    },
  },
  '/booking-inquiry/can-view/{id}/': {
    delete: {
      path: t.type({
        id: t.number,
      }),
      response: {
        204: t.any,
      },
    },
  },
  '/booking-inquiry/cancel-detail/{d2dNo}/': {
    patch: {
      path: t.type({
        d2dNo: t.string,
      }),
      body: inquiryCancelDetailBody,
      response: {
        200: inquiryCancelDetailBody,
      },
    },
  },
  '/booking-inquiry/{d2dNo}/logs/': {
    get: {
      path: t.type({
        d2dNo: t.string,
      }),
      response: {
        200: t.array(bookingInquiryChangeLog),
      },
    },
  },
  '/booking-inquiry/limits/': {
    get: {
      response: {
        200: bookingInquiryLimits,
      },
    },
  },
  '/booking-inquiry-draft/': {
    get: {
      response: {
        200: bookingInquiryDraft,
        404: t.type({}),
      },
    },
    post: {
      body: postBookingInquiryDraft,
      response: {
        201: t.type({}),
      },
    },
  },
});
